<template>
  <v-app id="inspire">
    <v-container>
      <div  ref="data1">
      <v-layout justify-center>
        <v-flex xs12 sm12 md12 lg12>
          <br />
          <p class="headlinestyle" align-center>
            <strong>{{title}}</strong>&nbsp;{{ orderdatas.order_no }}
          </p>
          <v-divider />
        </v-flex>
      </v-layout>
      <br />
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>เลขที่เอกสาร : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ orderdatas.order_no }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>รหัสร้านค้า : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ orderdatas.username }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>เจ้าหน้าที่ผู้ดูแล : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ orderdatas.adminref_name }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>ชื่อ-สกุล : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ orderdatas.name }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>ที่อยู่จัดส่ง : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ orderdatas.address }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>เบอร์โทร : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ orderdatas.tel }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>สินค้ารวม : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ amounproduct }} ชิ้น</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>ยอดรวม : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ amount }} บาท <small>(ราคาไม่รวมภาษี)</small></p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>วันที่สั่งซื้อ : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ order_date_th }}</p>
          </div>
        </v-flex>
      </v-layout>
      <v-layout align-center>
        <v-flex xs12 sm3 md3 lg3>
          <div class="ml-10">
            <p align="right">
              <strong>วันที่จัดส่ง : &nbsp;</strong>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm8 md8 lg8>
          <div>
            <p>{{ delivery_date_th }}</p>
          </div>
        </v-flex>
      </v-layout>

      <br />
      <v-layout justify-center>
        <div class="ml-10">
          <p align="center">
            <strong>รายละเอียดการชำระเงิน</strong>
          </p>
        </div>
      </v-layout>
      </div>
      <v-layout justify-center>
        <div>
          <img
            class="ml-10 image"
            :src="paymentconfirm_image"
            :close-on-background-click="true"
          />
        </div>
      </v-layout>
      <v-layout justify-center v-if="orderdatas.payment_related && orderdatas.payment_related.length !== 0">
        <p><small style='color: black;'>การชำระเงินที่เกี่ยวข้อง: &nbsp;{{ orderdatas.payment_related.toString().replace(/,/g, ', ') }}</small></p>
      </v-layout>
      <br />
    </v-container>
        <template>
          <v-layout row justify-center>
            <v-dialog v-model="dialog_download" persistent max-width="500">
              <v-card>
                <v-card-title class="headlinedialog">อนุมัติรายการสั่งสินค้านี้ ?</v-card-title>
                <v-card-text class="chartTitle">
                  กรุณาพิมพ์รายละเอียดการชำระเงินของรายการสั่งสินค้านี้ เมื่อมีการอนุมัติการชำระเงินเรียบร้อยแล้ว
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="pink lighten-3" @click="back()">ยกเลิก</v-btn>&nbsp;
                  <v-btn color="#E17A82" dark @click="approveanddownload()">อนุมัติการชำระเงินและพิมพ์</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </template>
  </v-app>
</template>

<script>
import axios from 'axios'
// import jsPDF from 'jspdf'
import swal from 'sweetalert'
import moment from 'moment'
moment.locale('th')
export default {
  data () {
    return {
      title: 'รายการสั่งซื้อ',
      headers: [
        {
          text: 'รหัสซื้อขาย',
          align: 'center',
          sortable: false,
          value: 'product_no'
        },
        { text: 'รูปสินค้า', align: 'center', sortable: false, value: 'image' },
        { text: 'ชื่อสินค้า', align: 'center', sortable: false, value: 'name' },
        { text: 'ราคา', align: 'center', sortable: false, value: 'price' },
        { text: 'จำนวน', align: 'center', sortable: false, value: 'quantity' },
        { text: 'ประเภท', align: 'center', sortable: false, value: 'type' }
      ],
      orderdatas: '',
      productitems: [],
      name: '',
      address: '',
      tel: '',
      order_status: '',
      order_date_th: '',
      delivery_date_th: '',
      delivered_date_th: '',
      amount: 0,
      amounproduct: 0,
      paymentconfirm_image: '',
      isedit: false,
      order_status_change: [],
      orderstatusitems: [
        { text: 'รอการอนุมัติ', value: '00' },
        { text: 'อนุมัติ', value: '01' },
        { text: 'ไม่อนุมัติ', value: '02' },
        { text: 'เตรียมจัดส่ง', value: '10' },
        { text: 'กำลังจัดส่ง', value: '11' },
        { text: 'จัดส่งสำเร็จ', value: '12' }
      ],
      delivery_modal: false,
      delivery_date: '',
      delivered_modal: false,
      delivered_date: '',
      isdelivery: false,
      isdelivered: false,
      paymentstatusitems: [
        { text: 'รอการชำระเงิน', value: '0' },
        { text: 'แจ้งโอนแล้วรอการอนุมัติ', value: '1' },
        { text: 'อนุมัติ', value: '2' },
        { text: 'ไม่อนุมัติ', value: '3' },
        { text: 'ไม่ต้องแจ้งโอน', value: '4' }
      ],
      payment_status_change: [],
      dialog_download: false,
      dialog_confirm: false,
      isprint: false
    }
  },
  methods: {
    async getorderdata () {
      try {
        let currenid = window.location.pathname.split('/')[2]
        let { data } = await axios.get(`${process.env.VUE_APP_API}/order/get/${currenid}`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        if (data) {
          for (const key in data) {
            this[key] = data[key]
          }
          this.orderdatas = data
          this.delivery_date = data.delivery_date ? data.delivery_date.split('T')[0] : ''
          this.delivered_date = data.delivered_date ? data.delivered_date.split('T')[0] : ''
          this.order_date_th = moment(data.order_date).format('LL')
          this.delivery_date_th = data.delivery_date ? moment(data.delivery_date).format('LL') : ''
          this.delivered_date_th = data.delivered_date ? moment(data.delivered_date).format('LL') : ''
          this.paymentconfirm_image = data.paymentconfirm_image ? `${process.env.VUE_APP_API}${data.paymentconfirm_image}` : ''
          this.amount = data.productitems ? data.productitems.reduce((sum, product) => {
            return sum + (Number(product.price) * Number(product.quantity))
          }, 0) : 0
          this.amounproduct = data.productitems ? data.productitems.reduce((sum, product) => {
            return sum + Number(product.quantity)
          }, 0) : 0
          swal({
            title: `อนุมัติรายการสั่งสินค้านี้ ?`,
            text: 'กรุณาพิมพ์รายละเอียดการชำระเงินของรายการสั่งสินค้านี้ เมื่อมีการอนุมัติการชำระเงินเรียบร้อยแล้ว',
            dangerMode: true,
            buttons: ['ยกเลิก', 'อนุมัติการชำระเงินและพิมพ์']
          }).then(async (confirm) => {
            if (confirm) {
              this.approveanddownload()
            } else {
              this.back()
            }
          })
        }
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    back () {
      this.$router.push('/approvepayment')
    },
    async approveanddownload () {
      try {
        let currenid = window.location.pathname.split('/')[2]
        await axios.put(`${process.env.VUE_APP_API}/order/edit/confirmpayment/${currenid}`, {
          payment_status: true
        }, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.print()
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    async print () {
      try {
        this.dialog_download = false
        setTimeout(() => {
          window.print()
        }, 400)
        window.onafterprint = function (e) {
          swal({
            title: `พิมพ์รายละเอียดการชำระเงิน ?`,
            text: 'คุณแน่ใจว่าได้พิมพ์รายละเอียดการชำระเงินเรียบร้อยหรือไม่ เมื่อออกจากหน้านี้จะไม่สามารถพิมพ์รายละเอียดการชำระเงินได้อีก',
            dangerMode: true,
            buttons: ['พิมพ์อีกครั้ง', 'ยืนยัน'],
            closeOnClickOutside: false
          }).then(async (confirm) => {
            if (confirm) {
              let path = window.location.href.split('download/')[0]
              window.location.href = `${path}approvepayment`
            } else {
              this.print()
            }
          })
        }
      } catch (error) {
      }
    },
    opendialog () {
      this.dialog_confirm = true
    }
  },
  computed: {
  },
  watch: {},
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin' || this.$cookies.get('status') === 'admin') {
        this.getorderdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  }
}
</script>

<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  line-height: 40px;
  color: #000000;
}
.v-chip {
  font-family: 'Kanit';
}
.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-data-table {
  font-family: 'Kanit';
}
.v-list-item {
  font-family: 'Kanit';
}
.v-text-field {
  font-family: 'Kanit';
}
p {
  font-family: 'Kanit';
}
.headlinedialog {
  font-family: 'Kanit';
}
.v-card {
  font-family: 'Kanit';
}

.swal-button--danger {
  background-color: #E17A82;
  border: 0px;
  width: 200px;
}

</style>

<style scoped>
.image {
  position: relative;
  width: 200px;
  max-width: 100%;
}
td {
  max-width: 110px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}

</style>
